/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid binary — use 0s and 1s in groups of 8 bits.`)
};

const es_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario inválido — usa 0s y 1s en grupos de 8 bits.`)
};

const de_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Binärcode — verwende 0 und 1 in Gruppen von 8 Bit.`)
};

const nl_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig binair — gebruik 0en en 1en in groepen van 8 bits.`)
};

const fr_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire invalide — utilisez 0 et 1 par groupes de 8 bits.`)
};

const it_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario non valido — usa 0 e 1 in gruppi di 8 bit.`)
};

const pt_br2_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário inválido — use 0s e 1s em grupos de 8 bits.`)
};

const pt_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário inválido — use 0s e 1s em grupos de 8 bits.`)
};

const ja_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なバイナリです。0 と 1 を 8 ビットのグループで使用してください。`)
};

const zh_tb_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效的二进制 — 请使用由8位一组的0和1。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_invalid", locale)
	if (locale === "en") return en_tb_invalid(inputs)
	if (locale === "es") return es_tb_invalid(inputs)
	if (locale === "de") return de_tb_invalid(inputs)
	if (locale === "nl") return nl_tb_invalid(inputs)
	if (locale === "fr") return fr_tb_invalid(inputs)
	if (locale === "it") return it_tb_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_tb_invalid(inputs)
	if (locale === "pt") return pt_tb_invalid(inputs)
	if (locale === "ja") return ja_tb_invalid(inputs)
	return zh_tb_invalid(inputs)
};